/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_03_Detail_Beginner_1_HeadingInputs */

const en_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What slow-motion video reveals`)
};

const es_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué revela el video a cámara lenta`)
};

const de_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ein Zeitlupenvideo verrät`)
};

const zh_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`慢动作视频揭示了什么`)
};

const ar_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما يكشفه الفيديو البطيء`)
};

const fr_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce que révèle la vidéo au ralenti`)
};

const vi_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video chậm tiết lộ điều gì`)
};

const sw_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kile ambacho video ya mwendo wa polepole inafichua`)
};

const th_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิ่งที่วิดีโอสโลว์โมชันเผยให้เห็น`)
};

const bs_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šta otkriva usporeni snimak`)
};

const ja_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スローモーション映像が明かすこと`)
};

const ko_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`슬로모션 영상이 보여 주는 것`)
};

const pt_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que o vídeo em câmera lenta revela`)
};

const it_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che cosa rivela il video al rallentatore`)
};

const sv_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vad slowmotionvideo avslöjar`)
};

const nl_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat slow-motionvideo laat zien`)
};

const da_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad slowmotionvideo afslører`)
};

const nb_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hva sakte film avslører`)
};

const fi_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitä hidastettu video paljastaa`)
};

const pl_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co pokazuje nagranie w zwolnionym tempie`)
};

const ru_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что показывает замедленное видео`)
};

const tr_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ağır çekim videonun ortaya koydukları`)
};

const hi_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्लो-मोशन वीडियो क्या दिखाता है`)
};

const id_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang diungkap video gerak lambat`)
};

const ms_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang didedahkan oleh video gerak perlahan`)
};

const cs_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co odhalí zpomalené video`)
};

const el_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τι αποκαλύπτει το βίντεο σε αργή κίνηση`)
};

const he_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מה חושף וידאו בהילוך איטי`)
};

const af_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat slow-motion-video onthul`)
};

const hu_method_content_step_03_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amit a lassított felvétel megmutat`)
};

/**
* | output |
* | --- |
* | "What slow-motion video reveals" |
*
* @param {Method_Content_Step_03_Detail_Beginner_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_03_detail_beginner_1_heading = /** @type {((inputs?: Method_Content_Step_03_Detail_Beginner_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_03_Detail_Beginner_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "de") return de_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "zh") return zh_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "ar") return ar_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "fr") return fr_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "vi") return vi_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "sw") return sw_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "th") return th_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "bs") return bs_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "ja") return ja_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "ko") return ko_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "pt") return pt_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "it") return it_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "sv") return sv_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "nl") return nl_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "da") return da_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "nb") return nb_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "fi") return fi_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "pl") return pl_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "ru") return ru_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "tr") return tr_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "hi") return hi_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "id") return id_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "ms") return ms_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "cs") return cs_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "el") return el_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "he") return he_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "af") return af_method_content_step_03_detail_beginner_1_heading(inputs)
	if (locale === "hu") return hu_method_content_step_03_detail_beginner_1_heading(inputs)
	return en_method_content_step_03_detail_beginner_1_heading(inputs)
});